<div class="flex flex-col flex-1 h-full">
  <app-header></app-header>

  @if ('@trust-center-tab' | isFeatureEnabled) {
    <app-global-loader></app-global-loader>
    <router-outlet></router-outlet>
  } @else {
    <app-trust-empty-state></app-trust-empty-state>
  }
</div>
